// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"eC5bC","rc-tabs-tab-active":"PJ3ep","input-suffix":"gjJoH","nav-item":"uCWem","shape":"FKcCV","name":"UNemz"};